module.exports = __webpack_public_path__ + "static/media/differential-fluid-exchange.01800a7f.svg";